import React from "react";
import { BillTransaction, Payment, Transaction } from "../../../api/services";
import { formatSpacedString } from "../../../utils/formatStringSpacing";
import { formatBillPeriod } from "../utils/formatBillPeriod";
import { formatDate } from "../../../utils/formatDate";
import { ChipLabel } from "../../../components/Chip";

export interface TransactionSummaryProps {
  transaction: Transaction;
}

export const TransactionSummary: React.FC<TransactionSummaryProps> = ({
  transaction,
}) => {
  return !transaction.isCancellation ? (
    <TransactionBaseSummary transaction={transaction} />
  ) : (
    // Cancellation transactions have the summary details for the transaction they are reversing
    <>
      Reversed transaction: <TransactionBaseSummary transaction={transaction} />{" "}
      ({formatDate(transaction.cancellationDttm)})
    </>
  );
};

const TransactionBaseSummary: React.FC<TransactionSummaryProps> = ({
  transaction,
}) => {
  if (transaction.type === "Payment") {
    if ("method" in transaction && "paymentStatus" in transaction) {
      const payment = transaction as Payment;
      const { paymentStatus, method, isCancellation } = payment;
      const chips =
        paymentStatus !== "Successful" && !isCancellation
          ? [formatSpacedString(payment.paymentStatus)]
          : null;
      return method && paymentStatus ? (
        <ChipLabel label={method} chips={chips} />
      ) : null;
    }
  } else if (transaction.type === "Bill" || transaction.type === "CreditNote") {
    if ("fromDttm" in transaction && "toDttm" in transaction) {
      const bill = transaction as BillTransaction;
      // Inclusive end date of bill period
      return (
        <>
          {bill.fromDttm && bill.toDttm
            ? formatBillPeriod(bill.fromDttm, bill.toDttm)
            : "Manual Bill"}
        </>
      );
    }
  } else if (transaction.type === "Repayment") {
    return transaction?.description ? <>{transaction?.description}</> : null;
  } else {
    return (
      <>
        {[transaction?.reference, transaction?.description]
          .filter((value) => !!value)
          .join(" - ")}
      </>
    );
  }
  return null;
};
